export const formatTimestamp = (timestamp) => {
  return new Date(timestamp).toLocaleTimeString([], { 
    hour: '2-digit', 
    minute: '2-digit', 
    hour12: false 
  });
};

/**
 * Issue #70: ISO 文字列 / Date を「YYYY年M月D日」に整形する（月日はゼロ埋めしない）。
 * 整形できない値（null / undefined / 空文字 / 不正な日付 / 文字列でも Date でもない値）は
 * null を返す。呼び出し側が非描画を選べるようにするためで、"Invalid Date" や "NaN年" は返さない。
 * Intl / toLocaleDateString は使わない（実行環境の ICU 有無に依存させないため）。
 */
export const formatJapaneseDate = (value) => {
  const date = toValidDate(value);
  if (!date) return null;
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
};

const toValidDate = (value) => {
  let date = null;

  if (value instanceof Date) {
    date = value;
  } else if (typeof value === 'string') {
    if (value.trim() === '') return null;
    date = new Date(value);
  } else {
    // number / boolean / object / null / undefined は日付として受け付けない
    return null;
  }

  if (Number.isNaN(date.getTime())) return null;
  return date;
};
